<template>
  <div style="padding: 16px">
    <el-form :model="form" ref="form" label-width="120px">
      <el-form-item v-if="false" :label="$t('tree.信息模板')">
        <el-select v-model="form.messageType" :placeholder="$t('tree.请选择信息模板')">
          <el-option v-for="template in messageTemplates" :key="template.value" :label="template.label"
            :value="template.value"></el-option>
        </el-select>
        <i class="el-icon-plus" @click="addTemplate" :title="$t('tree.新增模板')"></i>
        <i class="el-icon-edit" @click="editTemplate" :title="$t('tree.编辑模板')"></i>
        <i class="el-icon-delete" @click="deleteTemplate" :title="$t('tree.删除模板')"></i>
      </el-form-item>
      <el-form-item :label="$t('tree.播放方式')">
        <!-- 修改部分 -->
        <el-checkbox-group v-model="form.playMode" style="text-align: left;">
          <el-checkbox :label="0" :title="$t('tree.紧急')">{{$t('tree.紧急')}}</el-checkbox>
          <el-checkbox :label="2" :title="$t('tree.显示器显示')">{{$t('tree.显示器显示')}}</el-checkbox>
          <el-checkbox :label="3" :title="$t('tree.语音播报')">{{$t('tree.语音播报')}}</el-checkbox>
          <el-checkbox :label="4" :title="$t('tree.广告屏显示')">{{$t('tree.广告屏显示')}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item :label="$t('tree.信息内容')">
        <el-input v-model="form.messageContent" type="textarea" rows="4"></el-input>
      </el-form-item>
      <el-form-item :label="$t('tree.发送结果')">
        <el-input v-model="form.sendResult" disabled></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="submitForm('form')">{{$t('tree.发送')}}</el-button>
        <el-button @click="resetForm('form')">{{$t('tree.重置')}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { queryVideoDeviceNoRecorder } from "@/http/vehicle";
export default {
  props: {
    vehicleInfo: {
      type: Object,
      default: {
        vehicleName: "",
        nodeValue: 0,
      },
    },
  },
  watch: {
    "form.messageType": {
      handler(newValue) {
        const selectedTemplate = this.messageTemplates.find(
          (template) => template.value === newValue
        );
        if (selectedTemplate) {
          this.form.messageContent = selectedTemplate.value;
        }
      },
    },
    vehicleInfo: {
      handler() {
        console.log("开启视频1");
        this.carNo = this.vehicleInfo.vehicleName;
        this.ManufactureID = this.vehicleInfo.manuID;

        //todo 先去获取车辆的视频终端编号，然后开启视频
        this.checkOpenVideo();
      },
      immediate: true,
    },
  },
  data() {
    return {
      form: {
        messageType: "",
        playMode: [2, 3],
        messageContent: "",
        sendResult: "",
      },
      messageTemplates: [
        { label: "超速提醒", value: "超速提醒内容" },
        { label: "油耗提醒", value: "油耗提醒内容" },
        // 可以根据实际情况添加更多选项
      ],
      deviceNo: "", //"004014000022"" 004010000136
    };
  },

  beforeDestroy() {
    this.socketClient.DetachEvent(
      "SINGLEMSGVEL",
      this.socketClient.eventType.onSendInfomationAck
    );
  },
  created() {
    this.socketClient.AttachEvent(
      "SINGLEMSGVEL",
      this.socketClient.eventType.onSendInfomationAck,
      this.onSendInfomationAck
    );
  },
  methods: {
    checkOpenVideo() {
      //通过车号获取车辆的视频编号，如果没有，提示没有，如果有，开启视频
      //有行驶记录仪，不一定有视频设备，
      queryVideoDeviceNoRecorder({
        ManufactureID: this.ManufactureID,
      }).then((res) => {
        // console.log(res);
        if (res.code == 200 && res.data.length > 0 && res.data[0].DeviceNo != "") {
          this.deviceNo = res.data[0].DeviceNo;
          
        }
        else {
          //提示，没有视频设备
          this.$message({
            message: this.$t("tree.该车辆没有配置行驶记录仪设备,请联系销售人员"),
            type: "warning",
          })
        }
      });
      // this.deviceNo="004014000022";
      // 
    },
    addTemplate() {
      // 增加模板的逻辑
      this.$prompt(this.$t("tree.请输入新的信息模板名称"), this.$t("public.tips"), {
        confirmButtonText: this.$t("public.confirm"),
        cancelButtonText: this.$t("public.cancel"),
      }).then(({ value }) => {
        const newTemplate = {
          label: value,
          value: this.form.messageContent,
        };
        // 将新模板添加到 messageTemplates 数组中
        this.messageTemplates.push(newTemplate);
      }).catch(() => {

      });


    },
    editTemplate() {
      // 编辑模板的逻辑
      const selectedTemplateValue = this.form.messageType;
      if (!selectedTemplateValue) {
        this.$message.warning(this.$t("tree.请先选择一个信息模板"));
        return;
      }

      const selectedTemplate = this.messageTemplates.find(
        (template) => template.value === selectedTemplateValue
      );
      if (selectedTemplate) {
        this.$prompt(this.$t("tree.请输入新的信息模板名称"), this.$t("public.tips"), {
          confirmButtonText: this.$t("public.confirm"),
          cancelButtonText: this.$t("public.cancel"),
        }).then(({ value }) => {
          selectedTemplate.label = value;
          // 新增：将 messageContent 的内容保存到模板的 value 中
          selectedTemplate.value = this.form.messageContent;
        }).catch(() => {

        });


      }
    },
    deleteTemplate() {
      // 删除模板的逻辑
      const selectedTemplateValue = this.form.messageType;
      if (!selectedTemplateValue) {
        this.$message.warning(this.$t("tree.请先选择一个信息模板"));
        return;
      }

      const templateIndex = this.messageTemplates.findIndex(
        (template) => template.value === selectedTemplateValue
      );
      if (templateIndex !== -1) {
        this.messageTemplates.splice(templateIndex, 1);
        this.form.messageType = ""; // 清空选中的模板
        this.$message.success(this.$t("tree.模板删除成功"));
      }
    },
    DeviceResponseResult(v_params) {
      var resultMsg = "";
      var szResult = v_params.result;
      switch (szResult) {
        case 0:
          resultMsg = "";
          break;
        case 1:
          resultMsg = this.$t("public.Fail");
          break;
        case 2:
          resultMsg = this.$t("deviceresponse.msgError");
          break;
        case 3:
          resultMsg = this.$t("deviceresponse.noSupport");
          break;
        case 0x80:
          resultMsg = this.$t("deviceresponse.offLine");
          break;
        case 0x81:
          resultMsg = this.$t("deviceresponse.noAnswer");
          break;
      }
      return resultMsg;
    },

    onSendInfomationAck(v_params) {
      //消息通知应答
      var resultMsg = this.DeviceResponseResult(v_params);
      if (resultMsg != "") {
        this.form.sendResult = resultMsg;
      } else {
        this.form.sendResult = this.$t("tree.下发成功");
      }
    },
    getMsgPlayType() {
      var msgPlayType = 0;
      var mask = 0;

      this.form.playMode.forEach((element) => {
        mask = 1 << element;
        msgPlayType = msgPlayType | mask;
      });
      console.log(msgPlayType);
      return msgPlayType;
    },
    submitForm(formName) {
      var playType = this.getMsgPlayType(); //消息播放方式
      if (playType == 0) {
        //至少选择一种播放方式
        this.$message.warning(this.$t("tree.请先选择一种播放方式"));
        return;
      }
      if (!this.form.messageContent) {
        this.$message.warning(this.$t("tree.请输入信息内容"));
        return;
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.socketClient.socket.SendInfomation(
            this.deviceNo,
            playType,
            this.form.messageContent
          );
          //websocket信息发送
          this.form.sendResult = this.$t("tree.信息下发中...");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
      // 手动将 form 里的元素内容恢复到初始状态
      this.form = {
        messageType: "",
        playMode: [2, 3],
        messageContent: "",
        sendResult: "",
      };
    },
  },
};
</script>

<style scoped>
/* 可以添加一些自定义样式 */
.el-icon-plus,
.el-icon-edit,
.el-icon-delete {
  font-size: 16px;
  margin-left: 16px;
  cursor: pointer;
}
</style>
